<template>
  <div class="middle-box text-center animated fadeInDown">
    <h1>404</h1>
    <h3 class="font-bold">Unauthorized</h3>
    <div class="error-desc">
      Lo sentimos, el acceso a la página es denegado.
      No cuentas con los permisos para ver está página.
      <p class="message-instruction">
        Aguarde un momento por favor, serás redireccionado al inicio del sitio.
      </p>
      <div class="sk-spinner sk-spinner-circle message-spinner">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PageUnauthorized"
  , head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    let _locale = this.$store.language;
    return {
      locale: _locale
      , view:{
        title:"401 Unauthorized"
        , errorMessage:{
          visible:false
          , text:""
        }
      }
    };
  }
  ,methods: {
    redirecToLoginView(data){
      setTimeout( () => this.$router.push({name:'SignIn'})
      , 5000);
    }
  }
  , computed:{}
  , created(){
    this.redirecToLoginView();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.message-instruction{
  margin-bottom: 15px;
  margin-top: 15px;
}


</style>



// WEBPACK FOOTER //
// src/views/error/401.vue